import Vue from 'vue';
import App from './App';
import store from './store';
import router from './router';
import moment from 'moment';
import Cookie from 'vue-cookie';
import vuelidate from 'vuelidate';
import filters from './utils/filters';
import prototype from './utils/prototype';
import glb from './utils/glbfunction';

import myDirectives from '@/directives';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import vueLazyload from 'vue-lazyload'; //引入这个懒加载插件

import CommonUpload from '@/components/Upload/index.vue'; //上传组件

//注册全局上传组件
Vue.component('CommonUpload', CommonUpload);

Vue.use(Cookie); // 注册 cookie
Vue.use(ElementUI, { size: 'mini' });
Vue.use(ElementUI.Form, { labelPosition: 'right', labelWidth: '80px' });
Vue.use(vuelidate); // 注册 表单验证
Vue.use(vueLazyload, { preLoad: 1.3, attempt: 1 });
Vue.use(prototype); // 自定义全局变量或函数
Vue.use(glb); // 自定义全局变量或函数
Vue.prototype.moment = moment;


Vue.use(myDirectives); // 自定义全局指令

//解决elementui中el-radio报错：Blocked aria-hidden on an element because its descendant retained focus.
Vue.directive('removeAriaHidden', {
    bind(el, binding) {
        let ariaEls = el.querySelectorAll('.el-radio__original');
        ariaEls.forEach(item => {
            item.removeAttribute('aria-hidden');
        });
    },
});

Object.keys(filters).forEach(key => Vue.filter(key, filters[key]));

new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js